import { Icons } from "@/assets/images";
import { SIGN_IN_REASONS } from "@/shared/constants/auth.constants";
import React from "react";
import type { SignInInProgressProps } from "./types/SignInInProgress.type";

const SignInInProgress = ({
  reason,
  onSignInHere,
}: SignInInProgressProps): React.ReactElement => {
  return (
    <div
      role="status"
      className="relative isolate flex min-h-screen items-center justify-center bg-black p-6 text-center"
    >
      <img
        src={Icons.authBackground}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 -z-10 h-full w-full object-cover"
      />
      <div className="flex w-full max-w-108 flex-col items-center rounded-[20px] bg-white p-6 text-black sm:p-8">
        <img
          src={Icons.siteLogoIcon}
          alt="Logo"
          className="mb-[21.4px] h-auto w-[157px] max-w-full"
        />

        <p className="font-semibold text-base tracking-normal mb-2 sm:mb-3">
          {reason === SIGN_IN_REASONS.signedOut
            ? "You have been signed out"
            : "Sign-in already in progress"}
        </p>

        <div className="max-w-108 space-y-7.5 text-sm">
          <p className="text-placeholder tracking-wide leading-[1.5]">
            {reason === SIGN_IN_REASONS.signedOut
              ? "Your session was signed out in another tab. Complete sign-in there, or select Sign in here to start a new sign-in in this tab."
              : "Sign-in is already open in another tab. Complete it there, or select Sign in here to start a new sign-in in this tab."}{" "}
            This tab will refresh automatically after you sign in.
          </p>

          <button
            type="button"
            onClick={onSignInHere}
            className="w-full bg-primary inline-block text-pure-white px-5 py-2.5 rounded-10 hover:bg-primary/90 transition-all duration-500 font-semibold tracking-wide cursor-pointer"
          >
            Sign in here
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignInInProgress;
